export default "__VITE_ASSET__Br7m5JbC__"